module.exports = __webpack_public_path__ + "img/feat_xplatform.b4b63dcb.png";